import React from 'react';

import { Box, Typography } from '@mui/joy';

import { useCampaignStreams } from '../../hooks/useCampaignStreams';
import AntMediaVideo from '../../pilot/components/AntMediaVideo';
import ControlledAntMediaVideo from '../../pilot/components/ControlledAntMediaVideo';

interface AntMediaStreamViewerProps {
  /** ID of the campaign whose streams we should subscribe to */
  campaignId: string | number;
}

const AntMediaStreamViewer: React.FC<AntMediaStreamViewerProps> = ({ campaignId }) => {
  const { streams, loading, error } = useCampaignStreams(campaignId);

  if (loading) {
    return <Typography level='body-sm'>Loading video stream</Typography>;
  }

  if (error) {
    return (
      <Typography level='body-sm' color='danger'>
        Failed to load streams: {error.message}
      </Typography>
    );
  }

  if (!streams.length) {
    return <Typography level='body-sm'>No streams found for this campaign.</Typography>;
  }

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
      {streams.map((stream) => (
        <>
          <ControlledAntMediaVideo
            key={stream.id ?? stream.id}
            streamId={stream.ant_media_stream_id}
            websocketUrl='wss://sifly.stockmasters.com/WebRTCAppEE/websocket'
          />
        </>
      ))}
    </Box>
  );
};

export default AntMediaStreamViewer;
